import {
  Box,
  Flex,
  Grid,
  Heading,
  PageHeader,
  Button,
  Text,
  useMatchBreakpoints,
  InputGroup,
  Input,
} from '@pancakeswap/uikit'
import Page from 'components/Layout/Page'
import styled, { useTheme } from 'styled-components'

import hawk2 from './images/qomswap-bird.png'
import Image from 'next/image'
import { tokens } from '@pancakeswap/ui'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { erc20ABI, useContractRead, useContractWrite } from 'wagmi'
import airdropABI from 'config/abi/airdrop.json'
import { useActiveChainId } from 'hooks/useActiveChainId'
import { useState } from 'react'
import { parseEther } from '@ethersproject/units'
import { ethers } from 'ethers'

const H1 = styled(Heading)`
  font-size: 32px;
  margin-bottom: 8px;
  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 64px;
    margin-bottom: 24px;
  }
`
const H2 = styled(Heading)`
  font-size: 16px;
  margin-bottom: 8px;
  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 24px;
    margin-bottom: 18px;
  }
`

const Filler = styled.div`
  min-height: 175px;
  ${({ theme }) => theme.mediaQueries.sm} {
    min-height: 0px;
  }
`

const Rocket = styled.div`
  display: none;
  ${({ theme }) => theme.mediaQueries.sm} {
    display: block;
    margin-right: 24px;
  }
`
const Rocket2 = styled.div`
  ${({ theme }) => theme.mediaQueries.sm} {
    display: none;
  }
`

const Airdrop: React.FC = () => {
  const { isDark } = useTheme()
  const { gradientBubblegum } = tokens.colors.light
  const { isMobile } = useMatchBreakpoints()
  const { account, provider, chainId: walletChainId } = useActiveWeb3React()
  const { chainId: appChainId } = useActiveChainId()
  const [accountTyped, setAccountTyped] = useState('')

  const { data, isError, isLoading } = useContractRead({
    addressOrName: '0x95c42C58863a682D53333e0FC1fF79041FCa779E',
    contractInterface: airdropABI,
    functionName: 'eligible',
    chainId: appChainId,
    args: [account || accountTyped],
    enabled: !!accountTyped,
  })

  const { data: dataClaimed } = useContractRead({
    addressOrName: '0x95c42C58863a682D53333e0FC1fF79041FCa779E',
    contractInterface: airdropABI,
    functionName: 'hasClaimed',
    chainId: appChainId,
    args: [account || accountTyped],
    enabled: !!accountTyped,
  })

  const { data: writeClaim, write: writeClaimResult } = useContractWrite({
    addressOrName: '0x95c42C58863a682D53333e0FC1fF79041FCa779E',
    contractInterface: airdropABI,
    functionName: 'claimTokens',
    chainId: appChainId,
    mode: 'recklesslyUnprepared',
  })

  const eligibilityStatus = data ? ethers.utils.formatUnits(data, 0) : ''

  // console.log('airdrop status', eligibilityStatus)

  // console.log('dataClaimed', dataClaimed)

  const handleInputChange = (event) => {
    setAccountTyped(event.target.value)
  }

  return (
    <Box background={isDark ? 'linear-gradient(135deg, #000000 0%, #141317 100%)' : gradientBubblegum}>
      <PageHeader
        // background={`url(${header.src})`}
        style={{
          backgroundPosition: 'right bottom',
          backgroundColor: '#000000',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Flex alignContent="center" alignItems="center" justifyContent="center">
          <Rocket>
            <Image src={hawk2.src} alt="Eagle Airdropping" width={150} height={150} />
          </Rocket>
          <Flex flexDirection="column">
            <H1 as="h1" color={isDark ? tokens.colors.dark.primary : tokens.colors.light.secondary} scale="xxl">
              Airdrop
            </H1>
            <H2 color="#F4EEFF">Our first airdrop is now live!</H2>
            {isMobile && (
              <Flex flexDirection="column" alignItems="center" justifyContent="center" width="100%" mt="24px">
                <Image src={hawk2.src} alt="Rocket" width={150} height={150} />
              </Flex>
            )}
            <Filler />
          </Flex>
        </Flex>
      </PageHeader>
      <Page>
        {account ? (
          <>
            <Flex
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              width="100%"
              mb="24px"
              padding="24px"
            >
              {eligibilityStatus !== null && Number(eligibilityStatus) > 0 ? (
                <>
                  <Text>
                    You are eligible for the airdrop. You will receive {ethers.utils.formatUnits(eligibilityStatus, 18)}{' '}
                    QSWAP tokens.
                  </Text>
                  {dataClaimed ? (
                    <Text color={isDark ? tokens.colors.dark.primary : tokens.colors.light.secondary}>
                      You have already claimed your airdrop.
                    </Text>
                  ) : (
                    <>
                      <Flex flexDirection="column" justifyContent="center" alignItems="center" width="100%">
                        <Text>You can claim your airdrop.</Text>
                      </Flex>
                      <Button onClick={() => writeClaimResult()}>Claim</Button>
                    </>
                  )}
                </>
              ) : (
                <Text color={isDark ? tokens.colors.dark.primary : tokens.colors.light.secondary}>
                  You are not eligible for this airdrop.
                </Text>
              )}
            </Flex>
          </>
        ) : (
          <>
            <Flex
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              width="100%"
              mb="24px"
              padding="24px"
            >
              <InputGroup mb={24}>
                <Input placeholder="0x..." width="100%" onChange={handleInputChange} value={accountTyped} />
              </InputGroup>
              {eligibilityStatus !== null && Number(eligibilityStatus) > 0 ? (
                <>
                  <Text>
                    You are eligible for the airdrop. You will receive {ethers.utils.formatUnits(eligibilityStatus, 18)}{' '}
                    QSWAP tokens.
                  </Text>
                  {dataClaimed ? (
                    <Text color={isDark ? tokens.colors.dark.primary : tokens.colors.light.secondary}>
                      You have already claimed your airdrop.
                    </Text>
                  ) : (
                    <Text>You can claim your airdrop.</Text>
                  )}
                </>
              ) : (
                <Text color={isDark ? tokens.colors.dark.primary : tokens.colors.light.secondary}>
                  You are not eligible for this airdrop.
                </Text>
              )}
              <Text color={isDark ? tokens.colors.dark.primary : tokens.colors.light.secondary}>
                Connect your account to claim your airdrop.
              </Text>
            </Flex>
          </>
        )}
      </Page>
    </Box>
  )
}

export default Airdrop
